import { SideBar } from './SideBar.tsx'
import useUserRoles from '../../hooks/useUserRoles.tsx'
import Register from '../../pages/03_Register_Profile/Register.tsx'
import Pages from './Pages.tsx'
import useFetchProfileData from '../../hooks/useFetchProfileData.tsx'


const PageLayout = () => {
  const { isDocentWithoutDocentId, isInternal } = useUserRoles()
  const profilePending = useFetchProfileData()


  return (
    <>
      <div className="nw-page">
        <div id={'targetElement'} className={'nw-mainContent'}>
          <SideBar register={(isDocentWithoutDocentId && !isInternal)} />
          <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            {(!profilePending || isInternal) ? (
              (isDocentWithoutDocentId && !isInternal) ? (<Register />) : (<Pages />)
            ) : (
              <div>Ihre Daten werden geladen....</div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default PageLayout
